export const CHAIN_IDS = {
  eth: {
    mainnet: 1,
    sepolia: 11155111,
    foundry: 31337,
  },
  fuel: {
    devnet: 1119889111,
    testnet: 0,
    mainnet: 9889,
  },
} as const;
